var _path, _path2, _path3, _path4;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhatsvoznoauthorized = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z",
    fill: "#FFB3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 15.9997C22.1666 12.6092 19.3904 9.83301 15.9999 9.83301C12.6094 9.83301 9.83325 12.6092 9.83325 15.9997C9.83325 19.3902 12.6094 22.1663 15.9999 22.1663C19.3904 22.1663 22.1666 19.3902 22.1666 15.9997ZM23.1666 15.9997C23.1666 19.9425 19.9427 23.1663 15.9999 23.1663C12.0571 23.1663 8.83325 19.9425 8.83325 15.9997C8.83325 12.0569 12.0571 8.83301 15.9999 8.83301C19.9427 8.83301 23.1666 12.0569 23.1666 15.9997Z",
    fill: "#AA0233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 16.6663V13.333C15.4999 13.0569 15.7238 12.833 15.9999 12.833C16.2761 12.833 16.4999 13.0569 16.4999 13.333V16.6663C16.4999 16.9425 16.2761 17.1663 15.9999 17.1663C15.7238 17.1663 15.4999 16.9425 15.4999 16.6663Z",
    fill: "#AA0233"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0021 17.9997C16.3703 17.9997 16.6688 18.2982 16.6688 18.6663C16.6688 19.0345 16.3703 19.333 16.0021 19.333H15.9963C15.6281 19.333 15.3296 19.0345 15.3296 18.6663C15.3296 18.2982 15.6281 17.9997 15.9963 17.9997H16.0021Z",
    fill: "#AA0233"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhatsvoznoauthorized, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whatsvoznoauthorized.80542413.svg";
export { ForwardRef as ReactComponent };